import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Pagination extends React.PureComponent {
    state = {
        current: this.props.current || 1,
        startCount: 1,
        acceptGo: false,
        goTop: this.props.goTop || false,
    };

    static propTypes = {
        total: PropTypes.number.isRequired,
        pageSize: PropTypes.number,
        onChange: PropTypes.func.isRequired,
        type: PropTypes.string,
        showQuickJumper: PropTypes.bool,
        current: (props, propName, componentName) => {
            // 校验current,必须为指定范围内的正整数
            const { total, pageSize, current } = props;
            const totalPage = Math.ceil(total / pageSize) || 1;
            const isPositiveInteger = /^[1-9]\d*$/.test(props[propName]);

            // console.log(current);

            if (current) {
                if (
                    props[propName] < 1 ||
                    props[propName] > totalPage ||
                    typeof props[propName] !== 'number' ||
                    !isPositiveInteger
                ) {
                    return new Error(
                        `'current' should be a number greater than or equal to 1, less than or equal to ${totalPage}`,
                    );
                }
            }
        },
        onRef: PropTypes.func,
        maxPageNum: PropTypes.number,
        goTop: PropTypes.bool,
    };

    static defaultProps = {
        total: 0,
        pageSize: 20,
        type: 'normal',
        showQuickJumper: false,
        current: 1,
        onRef: () => {},
        maxPageNum: 10000,
        goTop: false,
    };

    static getDerivedStateFromProps(nextProps, state) {
        let resCurrent = {};
        let resTotal = {};
        let resPageSize = {};

        if (nextProps.current !== state.current) {
            resCurrent = nextProps.current;
        }
        if (nextProps.total !== state.total) {
            resTotal = nextProps.total;
        }
        if (nextProps.pageSize !== state.pageSize) {
            resPageSize = nextProps.pageSize;
        }

        return {
            ...resCurrent,
            ...resTotal,
            ...resPageSize,
        };
    }

    componentDidMount = () => {
        this.props.onRef(this);
    };

    // 动态生成页码
    creatPage() {
        const { total, pageSize, maxPageNum } = this.props;
        const { current, startCount } = this.state;

        const totalPage = Math.ceil(total / pageSize) > maxPageNum ? maxPageNum : Math.ceil(total / pageSize);

        const pages = [];

        // console.log(totalPage);

        if (totalPage <= 3) {
            // 总页数小于9
            pages.push(<li key={0} onClick={this.goPrev.bind(this)} className={styles.prevPage} />);
            for (let i = 1; i <= totalPage; i++) {
                pages.push(
                    <li key={i} onClick={this.go.bind(this, i)} className={current === i ? styles.active : ''}>
                        {i}
                    </li>,
                );
            }
            pages.push(
                <li key={totalPage + 1} onClick={this.goNext.bind(this, totalPage)} className={styles.nextPage} />,
            );
        } else {
            // 总页数大于9
            pages.push(<li key={0} onClick={this.goPrev.bind(this)} className={styles.prevPage} />);

            if (current < 2) {
                // 当当前页小于第六页时，渲染从第三页到第七页
                for (let i = startCount; i <= startCount + 2; i++) {
                    pages.push(
                        <li key={i} onClick={this.go.bind(this, i)} className={current === i ? styles.active : ''}>
                            {i}
                        </li>,
                    );
                }
            } else if (current > totalPage - 1) {
                // 当当前页大于倒数第一页时，渲染
                for (let i = totalPage - 2; i <= totalPage; i++) {
                    pages.push(
                        <li key={i} onClick={this.go.bind(this, i)} className={current === i ? styles.active : ''}>
                            {i}
                        </li>,
                    );
                }
            } else {
                // 中间状态(2 <= current <= total - 1)，渲染五页，当前页始终位于中间
                for (let i = current - 1; i <= current + 1; i++) {
                    pages.push(
                        <li key={i} onClick={this.go.bind(this, i)} className={current === i ? styles.active : ''}>
                            {i}
                        </li>,
                    );
                }
            }

            pages.push(
                <li key={totalPage + 1} onClick={this.goNext.bind(this, totalPage)} className={styles.nextPage} />,
            );
        }

        return pages;
    }

    creatSimple() {
        const { total, pageSize, maxPageNum } = this.props;
        const { current } = this.state;

        const totalPage = Math.ceil(total / pageSize) > maxPageNum ? maxPageNum : Math.ceil(total / pageSize);

        const pages = (
            <div className={`${styles.simple_wrap}`}>
                <div
                    className={`${current === 1 ? styles.nomore : ''} ${styles.s_fy_left}`}
                    style={{ display: current === 1 ? 'none' : 'block' }}
                    onClick={this.goPrev_s.bind(this)}
                />
                <div className={styles.fy_col}>
                    <span className={styles.fy_cur}>{current}</span>
                    {'/'}
                    <span>{totalPage}</span>
                </div>
                <div
                    className={`${current === totalPage ? styles.nomore : ''} ${styles.s_fy_right}`}
                    style={{ display: current === totalPage ? 'none' : 'block' }}
                    onClick={this.goNext_s.bind(this, totalPage)}
                />
            </div>
        );

        return pages;
    }

    // 普通样式点击事件
    // 点击事件
    go(current, totalPage) {
        // console.log('current=', current);
        const { onChange, pageSize } = this.props;
        const { goTop } = this.state;

        // console.log(startCount);
        this.setState({
            current,
        });

        // 返回当前翻页数据
        onChange({ pageNumber: current, pageSize });
        if (goTop) {
            // 返回页首
            window.scrollTo(0, 0);
        }
    }

    // 点击上一页
    goPrev() {
        let { current } = this.state;

        if (--current === 0) {
            return;
        }

        this.go(current);
    }
    // 点击下一页
    goNext(totalPage) {
        let { current } = this.state;

        if (++current > totalPage) {
            return;
        }

        this.go(current, totalPage);
    }

    // 简洁样式点击事件
    // 跳转事件
    go_s(current, totalPage) {
        const { onChange, pageSize } = this.props;
        const { goTop } = this.state;

        this.setState({
            current,
        });
        onChange({ pageNumber: current, pageSize });
        if (goTop) {
            // 返回页首
            window.scrollTo(0, 0);
        }
    }
    // 点击上一页事件
    goPrev_s() {
        let { current } = this.state;

        if (--current === 0) {
            return;
        }

        this.go_s(current);
    }

    // 点击下一页事件
    goNext_s(totalPage) {
        let { current } = this.state;

        if (++current > totalPage) {
            return;
        }

        this.go_s(current, totalPage);
    }

    // 跳页事件
    goTarget(type, totalPage) {
        const targetCurrent = this.refs.go_input.value;

        if (this.state.acceptGo && targetCurrent) {
            const _targetCurrent = Number(targetCurrent);

            switch (type) {
                case 'normal':
                    this.go(_targetCurrent, totalPage);
                    break;
                case 'simple':
                    this.go_s(_targetCurrent);
                    break;

                default:
                    break;
            }
        }

        this.refs.go_input.value = '';
    }
    // 监控输入的数值
    checkInputValue(totalPage) {
        const targetCurrent = this.refs.go_input.value;
        const isNum = isNaN(Number(targetCurrent));

        // 检查是否为正整数
        const isPositiveInteger = /^[1-9]\d*$/.test(targetCurrent);

        // 修改允许跳页的状态
        if (!targetCurrent || isNum || targetCurrent < 1 || targetCurrent > totalPage || !isPositiveInteger) {
            this.setState({
                acceptGo: false,
            });
        } else {
            this.setState({
                acceptGo: true,
            });
        }
    }

    // 重置
    resetCur = () => {
        this.setState({
            current: 1,
        });
    };

    componentWillUnmount = () => {
        this.setState = () => {
            return null;
        };
    };

    render() {
        const Pages = this.creatPage();
        const Pages_s = this.creatSimple();

        const { total, pageSize, type, showQuickJumper, maxPageNum } = this.props;

        const totalPage = Math.ceil(total / pageSize) > maxPageNum ? maxPageNum : Math.ceil(total / pageSize);

        // 跳页组件
        const quickJumper = (
            <div className={styles.go}>
                <input
                    type="text"
                    className={styles.go_input}
                    ref="go_input"
                    onChange={this.checkInputValue.bind(this, totalPage)}
                    placeholder={'输入页码'}
                    onKeyDown={e => {
                        if (e.keyCode === 13) {
                            this.goTarget(type, totalPage);
                        }
                    }}
                />
                <div
                    className={`${styles.go_btn} ${!this.state.acceptGo ? styles.disable : ''}`}
                    onClick={this.goTarget.bind(this, type, totalPage)}>
                    跳转
                </div>
            </div>
        );

        return (
            <React.Fragment>
                <div className={styles.main}>
                    {(() => {
                        return <ul>{Pages}</ul>;
                    })()}
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(Pagination);
